export default __webpack_public_path__ + "static/media/scape.8bf65aa1.png";